import { render, staticRenderFns } from "./TestSimulation.vue?vue&type=template&id=13e0ef38&scoped=true&"
import script from "./TestSimulation.vue?vue&type=script&lang=js&"
export * from "./TestSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0ef38",
  null
  
)

export default component.exports